import { CalloutCard, SubsectionTitle, Subtitle } from '@if/mui'
import { Card, CardContent, CardHeader, Grid } from '@mui/material'
import { HeartPulse, ShieldCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const SITUATIONS = [
  { key: 'life', icon: HeartPulse },
  { key: 'disability', icon: ShieldCheck },
] as const

export const ProtectionPlanCoverage = () => {
  const { t } = useTranslation()
  return (
    <Card>
      <CardHeader
        disableTypography
        title={<SubsectionTitle>{t('protectionPlan.coverage.title')}</SubsectionTitle>}
        subheader={<Subtitle>{t('protectionPlan.coverage.subtitle')}</Subtitle>}
      />
      <CardContent>
        <Grid container spacing={2}>
          {SITUATIONS.map(({ key, icon }) => (
            <Grid key={key} size={{ xs: 12, md: 6 }}>
              <CalloutCard icon={icon} title={t(`protectionPlan.coverage.${key}.title`)}>
                {t(`protectionPlan.coverage.${key}.description`)}
              </CalloutCard>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  )
}
